export default "__VITE_ASSET__B2AqWBm4__";